/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import React, { useEffect, useState } from 'react';
import { InputLabel, Select, MenuItem } from '@material-ui/core';
import { StatusType } from '../../enums/status-type.enum';
import useStyles from './styles';
import { useWriters } from '../../hooks/context/useWriters.hook';

interface ISelectWritersProps {
  writerId: string;
  status: number;
  onChangeWriter: (newWriterId: string) => void;
  labelAll?: any;
  className?: string;
  error?: boolean;
}

export const SelectWriters: React.FC<ISelectWritersProps> = ({
  writerId,
  status,
  onChangeWriter,
  labelAll,
  className,
  error,
}) => {
  const classes = useStyles();

  const [writers] = useWriters();

  const [listWriters, setListWriters] = useState<IUser[]>([]);

  const handleChange = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    if (event.target.value === 'null') onChangeWriter('');
    else onChangeWriter(event.target.value as string);
  };

  useEffect(() => {
    if (writers.length > 0) {
      setListWriters(writers);
    }
  }, [writers]);
  return (
    <>
      <InputLabel
        error={
          error &&
          status === StatusType.Approved &&
          (!writerId || !writerId.length)
        }
        className={className || classes.inputLabel}
      >
        Writer
      </InputLabel>
      <Select
        fullWidth
        id="writerId"
        labelId="select-settings-writerId"
        onChange={handleChange}
        className={classes.marginDefault}
        value={writerId != null ? writerId : 'null'}
      >
        {labelAll && (
          <MenuItem key="" value="null" selected>
            All
          </MenuItem>
        )}
        {listWriters
          ? listWriters.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.name}
              </MenuItem>
            ))
          : null}
      </Select>
    </>
  );
};
